var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.031,
    height: 32,
    className: "icon",
    viewBox: "0 0 1025 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M513.344 0a512 512 0 1 0 0 1024 512 512 0 0 0 0-1024zm226.048 674.624-54.528 56.896-171.52-164.928L341.952 731.52l-54.592-56.896L456.576 512 287.36 349.312l54.592-56.768 171.392 164.8 171.52-164.8 54.528 56.768L570.176 512l169.216 162.624z"
  })));
};
export default SvgClose;